import React from 'react'
import { CardContainer, ContentCard } from './styles'

type props = {
  src: string
}

const CardLogo = ({ src }: props) => {
  return (
    <CardContainer>
      <ContentCard>
        <img src={src} alt="logo parceiros" />
      </ContentCard>
    </CardContainer>
  )
}

export default CardLogo
